import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import styles from './TableList.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { tooltipStyle, tooltip, cellWidth, priceFenToYuanCell } from '@/components/TableCell';
import { ReconciliationFeilds as rf } from '../../../types';
import { TableActionType as ta } from '@/util/enum';
import { dateFormat } from '@/util/format';

class TableList extends React.Component {

    _takeColumns = () => ([
        {
            title: '企业名称',
            dataIndex: rf.enterpriseName,
            key: rf.enterpriseName,
            width: cellWidth.big,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '对账周期',
            dataIndex: rf.startTime,
            key: rf.startTime,
            width: cellWidth.time,
            align: 'center',
            render: (text,record) => tooltip(`${dateFormat(text, 'YYYY.MM.DD')} - ${dateFormat(record[rf.endTime], 'YYYY.MM.DD')}`)
        },
        {
            title: '对账金额（元）',
            dataIndex: rf.amount,
            key: rf.amount,
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '状态',
            dataIndex: rf.stateDesc,
            key: rf.stateDesc,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '生成时间',
            dataIndex: rf.createTime,
            key: rf.createTime,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            width: cellWidth.normal,
            align: 'center',
            fixed: 'right',
            render: (text, item) => this._renderActionCell(item[rf.id], item)
        }
    ]);

    _renderActionCell = (key, item) => {
        const { tableAction } = this.props;

        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction(key, ta.detail, item)}>详情</div>
            </div>
        );
    }

    render() {
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(record) => record.id}
                    columns={this._takeColumns()}
                    dataSource={dataList}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableList.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default TableList;